import { useNavigate, useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";

import { useQuizOptions } from "../hooks/useQuizOptions";
import { useQuizQuestion } from "../hooks/useQuizQuestion";

import SpinnerFullPage from "../../../../components/loadingPage/SpinnerFullPage";
import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import Question from "./Question";
import CreateOption from "./CreateOption";
import Choice from "./Choice";
import Alerts from "../../../../components/Alerts";
import usePermission from "../../../../hooks/usePermission";
import { FaPlus } from "react-icons/fa6";
import CreateQuestion from "./CreateQuestion";

function OptionsData() {
    const { can } = usePermission();

    const navigate = useNavigate();
    const { courseId, lectureId, itemId, questionId } = useParams();

    const { quizOptions, isPending } = useQuizOptions({
        courseId,
        lectureId,
        itemId,
        questionId,
    });

    const { quizQuestion, isPending: isGettingQuestions } = useQuizQuestion({
        courseId,
        lectureId,
        itemId,
        questionId,
    });
    if (isPending || isGettingQuestions) return <SpinnerFullPage />;

    const { image, question } = quizQuestion.data.attributes;
    return (
        <div className="py-8">
            <div className="flex justify-end pb-4">
                <button
                    className="flex"
                    onClick={() =>
                        navigate(
                            `/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}`
                        )
                    }
                >
                    <span>الرجوع للأسالة</span>
                    <IoMdArrowRoundBack className="text-2xl text-blue-color-primary" />
                </button>
            </div>
            <div className="flex justify-between gap-4 pb-4">
                {/* Modal For Adding Options */}

                {can("create:course:lecture:quiz:quiestion:options") && (
                    <Modal>
                        <Modal.Open opens="addOption">
                            <Button
                                type="primary"
                                className="w-full rounded-lg"
                            >
                                إضافة أختيار
                            </Button>
                        </Modal.Open>
                        <Modal.Window name="addOption">
                            <CreateOption />
                        </Modal.Window>
                    </Modal>
                )}
                {can("create:course:lecture:quiz:quiestions") && (
                    <Modal>
                        <>
                            <Modal.Open opens="addRow">
                                <Button
                                    type="bordered"
                                    className="w-full text-lg font-medium text-white rounded-lg bg-primary-color-primary"
                                    endContent={<FaPlus />}
                                    size="md"
                                >
                                    إضافه سؤال اخر
                                </Button>
                            </Modal.Open>
                            <Modal.Window name="addRow">
                                <CreateQuestion />
                            </Modal.Window>
                        </>
                    </Modal>
                )}
            </div>

            {can("read:course:lecture:quiz:quiestions") && (
                <Question question={question} image={image} />
            )}
            {can("read:course:lecture:quiz:quiestion:options") &&
            quizOptions.data.length === 0 ? (
                <Alerts
                    variant={"filled"}
                    severity={"error"}
                    message={" لا يوجد اختيارات"}
                />
            ) : (
                <div className="grid w-full gap-6 py-5 md:grid-cols-2">
                    {quizOptions.data.map((questionOption, index) => (
                        <Choice
                            key={questionOption.id}
                            choice={questionOption}
                            optionNum={index}
                            type="edit"
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default OptionsData;
